/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-06 13:33:19
 * @LastEditors: sj
 * @LastEditTime: 2022-09-07 13:50:33
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

// 机构预警
export function remindCheckTenant(tenant: string): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/reminder/checkTenant`,
    method: 'POST',
    body: {
      tenant,
    },
  }
}

// 保存病历时
export interface SaveMedicalParams {
  disease: string
  medicalItems?: any[]
}
export function remindSaveMedical(body: SaveMedicalParams): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/reminder/saveMedical`,
    method: 'POST',
    body,
  }
}

// 保存处方时
export interface SaveRecipesParams {
  recipeName: string
  recipeItems?: any[]
}
export function remindSaveRecipes(body: SaveRecipesParams): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/reminder/saveRecipes`,
    method: 'POST',
    body,
  }
}

// 合规平台：获取需要发给本地服务的报文（如处方分析）
export interface CompliancePlatformPayloadParams {
  // 业务类型（区分业务，取值与后端约定）
  businessType: string
  // 就诊ID（必传）
  treatmentId: string | number
  // 处方ID（可空）
  recipeId?: string | number
  // 处方明细ID（可空）
  recipeItemId?: string | number
}
export function getCompliancePlatformsPayload(
  body: CompliancePlatformPayloadParams
): Request {
  return {
    url: `${API_PREFIX}/blade-reminder/compliancePlatforms/payload`,
    method: 'POST',
    body,
  }
}

// 合规平台返回的报文：method/url/headers/body 直接透传给本地服务
export interface CompliancePlatformPayload {
  interfaceName?: string
  method?: string
  url?: string
  contentType?: string
  headers?: Record<string, string>
  body?: any
}
